if (!customElements.get("m-topbar-slider")) {
  class MTopbarSlider extends HTMLElement {
    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 3;
      const slideContainer = this.querySelector(".swiper-container");
      this.topbar = this.closest(".m-topbar");
      this.slides = Array.from(this.querySelectorAll(".m-topbar__message-item"));

      if (!slideContainer) return;

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        autoplay: autoplay
          ? {
              delay: autoplaySpeed * 1000,
            }
          : false,
        loop: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
      });

      this.applyMessageColors(this.slider.realIndex || 0);
      this.slider.on("slideChange", () => {
        this.applyMessageColors(this.slider.realIndex || 0);
      });
    }

    applyMessageColors(index) {
      if (!this.topbar || !this.slides.length) return;

      const activeSlide = this.slides[index];
      if (!activeSlide) return;

      const backgroundColor = activeSlide.dataset.bgColor || "";
      const textColor = activeSlide.dataset.textColor || "";
      const hasCustomColors = Boolean(backgroundColor || textColor);

      if (hasCustomColors) {
        this.topbar.classList.add("m-topbar--message-colors");
        this.topbar.style.setProperty("--topbar-message-bg", backgroundColor);
        this.topbar.style.setProperty("--topbar-message-color", textColor);
      } else {
        this.topbar.classList.remove("m-topbar--message-colors");
        this.topbar.style.removeProperty("--topbar-message-bg");
        this.topbar.style.removeProperty("--topbar-message-color");
      }
    }
  }

  customElements.define("m-topbar-slider", MTopbarSlider);
}
